if (!customElements.get('rn-cart-upsell')) {
  customElements.define('rn-cart-upsell', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', event => event.stopPropagation());
      this.querySelector('[data-rn-upsell-add]')?.addEventListener('click', () => this.add());
    }
    async add() {
      const button = this.querySelector('[data-rn-upsell-add]');
      const error = this.querySelector('.rn-upsell-error');
      const id = this.querySelector('[data-rn-upsell-variant]')?.value;
      if (!id || button.disabled) return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      error.textContent = '';
      const drawer = document.querySelector('cart-drawer');
      const useDrawer = Boolean(drawer && this.closest('cart-drawer'));
      const payload = {items:[{id:Number(id), quantity:1}], sections_url:window.location.pathname};
      if (useDrawer) payload.sections = drawer.getSectionsToRender().map(s => s.id);
      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        if (useDrawer) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(result);
          requestAnimationFrame(() => drawer.querySelector('.drawer__close')?.focus());
        } else window.location.assign(window.routes?.cart_url || '/cart');
      } catch (failure) {
        error.textContent = failure.message || this.dataset.error;
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  });
}
